import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-logout",
  "use": "icon-logout-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-logout\"><path d=\"M4.5 21.5h9A1.502 1.502 0 0 0 15 20v-2.25h-1.5V20h-9V4h9v2.25H15V4a1.502 1.502 0 0 0-1.5-1.5h-9A1.502 1.502 0 0 0 3 4v16a1.501 1.501 0 0 0 1.5 1.5Z\" /><path d=\"m15.44 15.44 2.689-2.69H7.5v-1.5h10.629l-2.69-2.69L16.5 7.5 21 12l-4.5 4.5-1.06-1.06Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol